function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommaCarouselWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.199219 0.923828H29.4864V30.2099C29.4864 59.497 2.30773 68.9238 2.30773 68.9238V52.7755C10.9543 50.4587 16.7846 38.2026 14.6426 30.2099H0.199219V0.923828ZM38.2139 0.923828H67.5V30.2099C67.5 59.497 40.3203 68.9238 40.3203 68.9238V52.7755C48.968 50.4587 54.7982 38.2026 52.6573 30.2099H38.2139V0.923828Z",
    fill: "#ffffff",
    style: {
      fill: "#ffffff",
      fill: "#ffffff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommaCarouselWhite);
export default __webpack_public_path__ + "static/media/Comma_CarouselWhite.797430099570f849b9a0cb4af060eba3.svg";
export { ForwardRef as ReactComponent };